export const pluginConfig = {
  pluginId: 'featured-catalog',
};
